import React from "react";
import { type NextPage } from "next";
import { Section } from "components/section";
import { Page } from "components/page";
import { TextTitle } from "ui/text";
import { Button } from "ui/button";

const NotFound: NextPage = () => {
  return (
    <Page
      title="404"
      description="Sorry, we could not find what you were looking for."
      footerOptions={{ hideCta: true }}
    >
      <Section center my="0" py="hugest">
        <TextTitle
          align="center"
          size="xl"
          chip={{ text: "404 Error" }}
          title="Page not found"
          description="Sorry, we could not find what you were looking for."
          actions={
            <>
              <Button variant="secondary" href="/integrations">
                Explore integrations
              </Button>{" "}
              <Button hasRightChevron href="/">
                Return home
              </Button>
            </>
          }
        />
      </Section>
    </Page>
  );
};

export default NotFound;
